<template>
  <div class="dashboard-block">
    <h2>Notes</h2>

    <notes-list :notes="notes" @addNote="addNote" @deleteNote="deleteNote" @pin="(id) => { pinNote({ userId: talent.id, noteId: id }) }" />

  </div>

</template>

<script>

import {mapActions, mapState} from 'vuex'
import NotesList from '../notes/NotesList'

export default {

  props: {
    talent: {
      type: Object,
      required: true
    }
  },

  components: {
    NotesList
  },

  computed: {
    ...mapState('talent/note', ['notes'])
  },

  methods: {
    ...mapActions('talent/note', ['getNotes', 'storeNote', 'removeNote', 'pinNote']),

    addNote (text) {
      return this.storeNote({
        id: this.talent.id,
        payload: {
          text: text,
          user: this.$user
        } })
    },

    deleteNote (note) {
      return this.removeNote({
        id: this.talent.id,
        noteId: note.id
      })
    }
  },

  created () {
    this.getNotes(this.talent.id)
  }

}

</script>
